var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSuspensionContentProvider = exports.AutoSuspensionReason = void 0;
var Localize_1 = require("../../../gen-src/Localize");
var messages_1 = require("../../messages");
var MarkdownHtml_1 = require("../../utils/MarkdownHtml");
var MessagesWithEscapedMarkdown_1 = require("../MessagesWithEscapedMarkdown");
var NotificationDefaultProvider_1 = require("../NotificationDefaultProvider");
var UserNotificationType_1 = require("../UserNotificationType");
var AutoSuspensionReason;
(function (AutoSuspensionReason) {
    AutoSuspensionReason["FAILURES_LIMIT_REASON"] = "FailuresLimitThresholdExceeded";
})(AutoSuspensionReason = exports.AutoSuspensionReason || (exports.AutoSuspensionReason = {}));
var newLine = messages_1.Messages.newLine();
var AutoSuspensionContentProvider = (function (_super) {
    __extends(AutoSuspensionContentProvider, _super);
    function AutoSuspensionContentProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoSuspensionContentProvider.prototype.getNotificationTitle = function (notification) {
        return MarkdownHtml_1.escapeMarkdown(messages_1.Messages.autoSuspensionTitle());
    };
    AutoSuspensionContentProvider.prototype.getNotificationContent = function (notification) {
        var content = notification.content;
        var message = '';
        if (notification.type === UserNotificationType_1.UserNotificationType.AutoSuspension) {
            message += this.getSuspensionReasonMessage(notification);
            message += messages_1.Messages.autoSuspensionDetailsSectionTitle();
            if (content.suspendedViewsCount <= 1) {
                message +=
                    MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(messages_1.Messages.autoSuspensionViewCountSingularText, {
                        VIEW_COUNT: content.suspendedViewsCount.toString(),
                    }) + newLine;
            }
            else {
                message +=
                    MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(messages_1.Messages.autoSuspensionViewCountPluralText, {
                        VIEW_COUNT: content.suspendedViewsCount.toString(),
                    }) + newLine;
            }
            message +=
                messages_1.Messages.autoSuspensionSuspensionTimeTitle() +
                    messages_1.Messages.autoSuspensionTime({
                        AUTO_SUSPENSION_TIME: Localize_1.Formatters.formateDateTimeShort(notification.creationTime),
                    });
        }
        return message;
    };
    AutoSuspensionContentProvider.prototype.getSuspensionReasonMessage = function (notification) {
        var content = notification.content;
        var message = '';
        if (content.suspensionReason === AutoSuspensionReason.FAILURES_LIMIT_REASON) {
            message +=
                messages_1.Messages.autoSuspensionReasonTitle() +
                    messages_1.Messages.autoSuspensionFailureLimitReason({
                        FAILURE_COUNT_VALUE: content.suspensionLimit.toString(),
                        FAILURE_COUNT: content.suspensionLimit,
                        FAILURE_TIME_PERIOD: content.suspensionTimePeriod,
                    }) +
                    newLine;
        }
        return message;
    };
    return AutoSuspensionContentProvider;
}(NotificationDefaultProvider_1.NotificationDefaultProvider));
exports.AutoSuspensionContentProvider = AutoSuspensionContentProvider;
//# sourceMappingURL=AutoSuspensionContentProvider.js.map